export default __webpack_public_path__ + "static/modal01_01-sp-de5d8f3b2ede32c62fad9f2a2295a399.png";